import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import TextField from '@components/Forms/TextField';
import {faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import FormGroup from '@components/Forms/FormGroup';

import Button from '@components/Forms/Button';

import styles from './style.module.css';

import {FormEvent, useState} from 'react';
import {useRequest} from '@hooks/use-request';
import {toast} from 'react-toastify';
import {useRouter} from 'next/router';
import {useEffect} from 'react';
import {useTranslation} from 'next-i18next';
import {LocaleEnum} from '@enums/locale';

export default function RequiresRegistrationModal({
  isOpen,
  toggleModal,
  identifier,
  pageUrl,
}: {
  isOpen: boolean;
  toggleModal: () => void;
  identifier: number;
  pageUrl?: string;
}) {
  const {t} = useTranslation('common');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const router = useRouter();
  const locale = router.locale;

  const {errors, sendRequest} = useRequest(locale);

  const url =
    process.env.NEXT_PUBLIC_APP_URL +
    (pageUrl ? pageUrl : '/naytasivu/registration');

  const Message = {
    en: 'You have successfully registered for this content',
    'en-US': 'You have successfully registered for this content',
    fi: 'Olet onnistuneesti rekisteröitynyt tälle sisällölle',
    se: 'Du har registrerat dig för detta innehåll',
  };

  const handleRegistrationSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    await sendRequest({
      url: `pages/requiresregistration/${identifier}`,
      method: 'post',
      body: {email, name, url},
      onSuccess: () => {
        setEmail('');
        toast.success(Message[locale! as LocaleEnum], {
          autoClose: 1000,
        });
        toggleModal();
      },
    });
    setLoading(false);
  };

  useEffect(() => {
    if (isOpen) {
      setEmail('');
      setName('');
    }
  }, [isOpen]);
  return (
    <Modal
      key={111}
      contentClasses={styles.loginModalContent}
      isOpen={isOpen}
      center={true}
    >
      <ModalHeader toggle={toggleModal} className={styles.modalHeader}>
        <div className={styles.loginHeader}>
          <div className={styles.modalHeaderIcon}>
            <FontAwesomeIcon icon={faEyeSlash} />
          </div>
          <div className={styles.modelHeaderTitle}>
            <h4>{t<string>('cms_registration_form.heading')},</h4>
            <p>{t<string>('cms_registration_form.sub_heading')}.</p>
          </div>
        </div>
      </ModalHeader>
      <ModalBody classNames={styles.loginModalBody}>
        <div className="">
          <p>{t<string>('cms_registration_form.information')}</p>
          <form onSubmit={handleRegistrationSubmit}>
            <FormGroup>
              <label htmlFor="">
                {t<string>('cms_registration_form.email')}
              </label>
              <TextField
                onChange={e => setEmail(e.target.value)}
                required
                value={email}
                placeholder={t<string>('cms_registration_form.email')}
                type={'email'}
              />
              {errors.length > 0 && (
                <p
                  style={{fontSize: '14px'}}
                  className={'mb-0 text text-danger'}
                >
                  {
                    errors.find(
                      err =>
                        err.field === 'email' ||
                        err.field === 'callback_url' ||
                        err.field === undefined
                    )?.message
                  }
                </p>
              )}
            </FormGroup>
            <FormGroup classNames={'my-2'}>
              <label htmlFor="">
                {t<string>('cms_registration_form.name')}
              </label>
              <TextField
                onChange={e => setName(e.target.value)}
                required
                value={name}
                placeholder={t<string>('cms_registration_form.name')}
                type={'text'}
              />
              {errors.length > 0 && (
                <p
                  style={{fontSize: '14px'}}
                  className={'mb-0 text text-danger'}
                >
                  {errors.find(err => err.field === 'name')?.message}
                </p>
              )}
            </FormGroup>
            <FormGroup classNames={'mt-3 mb-3'}>
              <Button
                disabled={loading || !name || !email}
                type={'submit'}
                block={true}
              >
                {t<string>('cms_registration_form.send')}
              </Button>
            </FormGroup>
          </form>
        </div>
      </ModalBody>
    </Modal>
  );
}
